<img [src]="url" alt="" *ngIf="!isLoading"
(click)="onNoClick()">
<mat-spinner *ngIf="isLoading"></mat-spinner>